import { Observable, of } from 'rxjs'
import {
  catchError,
  distinctUntilChanged,
  map,
  take,
  timeout
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { Store } from '@ngrx/store'
import { ConfigurationOptionService } from '../configuration-option.service'
import { NotificationService } from 'src/app/core/notification.service'
import { configurationOptionSelectors } from '../configuration-option.selectors'
import { ISO4217CurrencyCodes } from 'src/app/shared/utils/currencyCodes'
import {
  AvailableCountry,
  AvailableCurrency,
  TranslatorService
} from 'src/app/core/translator.service'
import { configurationOptionActions } from '../configuration-option.actions'
import { Actions, ofType } from '@ngrx/effects'

@Component({
  selector: 'configuration-option-other-tab',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class ConfigurationOptionOtherTabComponent implements OnInit {
  public configFormValues$: Observable<any>
  public isLoading$: Observable<boolean>
  public ISO4217CurrencyCodes = Object.values(ISO4217CurrencyCodes)
  public availableCurrencies: AvailableCurrency[]
  public availableCountries: AvailableCountry[]
  public isCollapsed = false
  public configContractForm: Observable<any>
  public form: UntypedFormGroup

  constructor(
    private store: Store<AppState>,
    private fb: UntypedFormBuilder,
    private configOptionService: ConfigurationOptionService,
    private notificationService: NotificationService,
    private translatorService: TranslatorService,
    private actions$: Actions
  ) {}

  ngOnInit() {
    this.availableCurrencies = this.translatorService.availableCurrencies
    this.availableCountries = this.translatorService.availableCountries

    this.form = this.fb.group({
      adminemail: ['', []],
      currency: ['', []],
      default_country: ['', []],
      employee_calendar_days_ahead_available: ['', []],
      employee_calendar_max_date_available: ['', []]
    })
    this.configContractForm = this.store.select(
      configurationOptionSelectors.selectByKey,
      'employeeContractConfig'
    )
    this.configFormValues$ = this.store
      .select(configurationOptionSelectors.selectAll)
      .pipe(
        distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
        map((configOptions) =>
          this.configOptionService.mapEntitiesToObject(configOptions)
        )
      )

    this.isLoading$ = this.store.select(
      configurationOptionSelectors.selectIsLoading
    )
  }

  public onSubmit(form): void {
    this.actions$
      .pipe(
        ofType(configurationOptionActions.upsertMany),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe((action) =>
        action
          ? this.notificationService.emit('alerts.success', 'success')
          : null
      )

    this.configOptionService.updateOrCreateMany(form)
  }
}
